/**
 * Reviews Modal
 * Handles opening and closing of the reviews list modal
 */
;(function () {
  'use strict'

  // Get modal elements
  const modal = document.getElementById('reviews-list-modal')
  const openButton = document.getElementById('reviews-list-button')
  const closeButton = document.getElementById('reviews-list-modal-close-button')

  // Check if elements exist
  if (!modal || !openButton || !closeButton) {
    return
  }

  // Open modal
  openButton.addEventListener('click', function (e) {
    e.preventDefault()
    modal.showModal()
  })

  // Close modal on close button click
  closeButton.addEventListener('click', function (e) {
    e.preventDefault()
    modal.close()
  })

  // Close modal when clicking on backdrop
  modal.addEventListener('click', function (e) {
    const rect = modal.getBoundingClientRect()
    const isInDialog =
      rect.top <= e.clientY &&
      e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX &&
      e.clientX <= rect.left + rect.width

    if (!isInDialog) {
      modal.close()
    }
  })
})()
